import styled from 'styled-components';
import { Box, Paragraph } from '@99designs/emu';
import { colors, spaces } from '@99designs/emu/settings';
import { IconTick1, IconX1 } from '@99designs/icons';
import { FormattedFeatureName } from './FormattedFeatureName';
import type { ProductFeature } from '../../types';

const StyledParagraph = styled(Paragraph)`
    padding: 0 0 0 ${spaces['0.5bu']};
    white-space: pre-line;
`;

interface FeatureItemProps {
    feature: ProductFeature;
}

function FeatureItemIncluded({ feature }: FeatureItemProps) {
    return (
        <Box display="flex">
            <Box>
                <IconTick1 offsetRight color={colors.grey800} aria-label={__('available')} />
            </Box>
            <StyledParagraph>
                <FormattedFeatureName name={feature.name} linksReplacements={feature.links || {}} />
            </StyledParagraph>
        </Box>
    );
}

function FeatureItemExcluded({ feature }: FeatureItemProps) {
    return (
        <Box display="flex">
            <Box>
                <IconX1 offsetRight color={colors.grey300} aria-label={__('unavailable')} />
            </Box>
            <StyledParagraph color={colors.grey300}>
                <FormattedFeatureName name={feature.name} linksReplacements={feature.links || {}} />
            </StyledParagraph>
        </Box>
    );
}

export function FeatureItem({ feature }: FeatureItemProps) {
    return (
        <Box display="flex">
            {feature.included ? (
                <FeatureItemIncluded feature={feature} />
            ) : (
                <FeatureItemExcluded feature={feature} />
            )}
        </Box>
    );
}
